module.exports = __webpack_public_path__ + "media/images/redesign-images/collabs/influencers/logo-10k-nos-457bfaa7b25529d69ac10239fb3537ca.svg";